<template>
  <div class="wrapper">
    <Header v-if="($route.meta || {}).type != 'addCard'" />
    <div class="payment-container">
      <div class="price md:text-2xl">
        <h1>
          {{
            isAddCard
              ? "Add new Card"
              : "Awesome, Choose plan & subscribe to continue"
          }}
        </h1>
      </div>

      <div class="product-ctr flex-col sm:flex-row md:flex-row">
        <div v-for="price in prices" v-bind:key="price.id" class="product-card">
          <div>
            {{ price.product.name }}
          </div>
          <div>
            <span class="amount-txt">${{ price.unit_amount / 100 }}</span>
            <span class="per-label">per {{ price.recurring.interval }}</span>
          </div>
          <div class="select-btn-ctr">
            <button
              @click="selectProduct(price)"
              class="flex items-center px-3 py-1 border rounded text-custom border-custom hover:text-white focus:border-white focus:outline-none text-lg"
            >
              {{
                (selectedPrice || {}).id == (price || {}).id
                  ? "Selected"
                  : "Select"
              }}
            </button>
          </div>
          <div></div>
        </div>
      </div>

      <form class="card__container" @submit.prevent="submitPaymentForm()">
        <div class="card">
          <div v-if="(selectedPrice || {}).id" class="subscription-detail-ctr">
            <div>Subscribing to {{ selectedPrice.product.name }}</div>
            <div>
              Total Amount to be paid ${{ selectedPrice.unit_amount / 100 }}
            </div>
          </div>
          <div class="row credit">
            <div class="left">
              <label for="credit-debit-card">Debit/ Credit Card</label>
            </div>
          </div>
          <div class="row cardholder">
            <div class="info">
              <label for="cardholdername">Name</label>
              <input
                placeholder="e.g. Richard Bovell"
                id="cardholdername"
                type="text"
                v-model="cardInfo.name"
                :required="paymentType != 'paypal'"
              />
            </div>
          </div>
          <div class="row number">
            <div class="info">
              <div id="card-element" class="MyCardElement">
                <!-- Elements will create input elements here -->
              </div>

              <!-- We'll put the error messages in this element -->
              <div id="card-element-errors" role="alert"></div>
            </div>
          </div>
        </div>

        <div class="button">
          <button type="submit" v-if="isAddCard">
            <i class="bx bxs-lock"></i> Add Card
          </button>
          <button type="submit" v-else>
            <i class="bx bxs-megaphone"></i> Subscribe
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<!-- Facebook Pixel Code -->
<script>
!(function(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(
  window,
  document,
  "script",
  "https://connect.facebook.net/en_US/fbevents.js"
);
// eslint-disable-next-line no-undef
fbq("init", "261976718326827");
// eslint-disable-next-line no-undef
fbq("track", "PageView");
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=261976718326827&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<script>
import Header from "@/components/layout/Header.vue";
import Helper from "@/providers/helper";
import firebase from "firebase";
export default {
  name: "Welcome",
  components: {
    Header
  },
  mounted() {
    this.isAddCard = (this.$route.meta || {}).type == "addCard";
    this.setUpStripe();
    let user = firebase.auth().currentUser;
    firebase
      .database()
      .ref(`users/${user.uid}`)
      .on("value", snapshot => {
        this.userData = snapshot.val();
        console.log("UserData:", this.userData);
      });
    firebase
      .database()
      .ref(`subscriptions/${user.uid}`)
      .on("value", snapshot => {
        this.subscriptionData = snapshot.val();
        console.log("Subscription Data:", this.subscriptionData);
      });
  },
  data() {
    return {
      isAddCard: false,
      paymentType: "debit-credit-card",
      userData: null,
      enablePay: false,
      cardInfo: {
        name: "",
        number: "",
        expiry: {
          month: "",
          year: ""
        },
        cvv: ""
      },
      options: {
        creditCard: true,
        delimiter: "-"
      },
      prices: [],
      selectedPrice: {},
      subscriptionData: null
    };
  },
  created() {
    Helper.getStripeProducts()
      .then(prices => {
        this.prices = prices || [];
      })
      .catch(err => {
        console.log("err fetching prices");
      });
  },
  methods: {
    selectProduct(price) {
      this.selectedPrice = price;
    },
    displayError() {
      let displayError = document.getElementById("card-element-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    },
    setUpStripe() {
      var _this = this;
      if (window.Stripe) {
        const stripe = window.Stripe(
          "pk_live_519bxa1H9q88vhZpE8WewngaRckO7gwO0A1UtT0Az7kg6G5Kaeguwjv1LoOjriWIjskG2JpeR5YXcqEiXGuJHr8z400gNNn29jc"
        );
        var elements = stripe.elements();
        let style = {
          base: {
            fontSize: "16px",
            color: "#fff",
            fontFamily:
              "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#a0aec0"
            }
          }
        };
        this.card = elements.create("card", { style: style });
        // // Add an instance of the card UI component into the `card-element` <div>
        this.card.mount("#card-element");
        this.card.on("focus", function() {
          let el = document.getElementById("card-element-errors");
          el.classList.add("focused");
        });

        this.card.on("blur", function() {
          let el = document.getElementById("card-element-errors");
          el.classList.remove("focused");
        });
        let _this = this;

        this.card.on("change", function(event) {
          if (event.complete) {
            // enable payment button
            _this.enablePay = true;
          } else if (event.error) {
            // show validation to customer
            _this.enablePay = false;
          }
        });
        this.stripe = stripe;
      }
    },
    submitPaymentForm(e) {
      if (this.enablePay && (this.cardInfo.name || "").trim().length) {
        if (this.isAddCard) {
          this.createPaymentMethod({
            card: this.card
          });
          return false;
        }
        // If a previous payment was attempted, get the latest invoice
        const latestInvoicePaymentIntentStatus = (
          (this.subscriptionData || {}).latest_invoice || {}
        ).paymentIntentStatus;
        // const latestInvoicePaymentIntentStatus = localStorage.getItem(
        //   "latestInvoicePaymentIntentStatus"
        // );
        if (latestInvoicePaymentIntentStatus === "requires_payment_method") {
          this.subscriptionData.latest_invoice.invoiceId;
          // const invoiceId = localStorage.getItem("latestInvoiceId");
          const invoiceId = this.subscriptionData.latest_invoice.invoiceId;
          const isPaymentRetry = true;
          // create new payment method & retry payment on invoice with new payment method
          this.createPaymentMethod({
            card: this.card,
            isPaymentRetry,
            invoiceId
          });
        } else {
          if (!(this.selectedPrice || {}).id) {
            this.$vToastify.error("Please choose the Subscription Plan");
            return false;
          }
          // create new payment method & create subscription
          this.createPaymentMethod({
            card: this.card
          });
        }
      }
    },
    createPaymentMethod({ card, isPaymentRetry, invoiceId }) {
      // Set up payment method for recurring usage
      let billingName = this.cardInfo.name;

      this.stripe
        .createPaymentMethod({
          type: "card",
          card: card,
          billing_details: {
            name: billingName
          }
        })
        .then(result => {
          if (result.error) {
            console.log("error", result.error);
            this.$vToastify.error(result.error.message);
          } else {
            if (isPaymentRetry) {
              // Update the payment method and retry invoice payment
              this.retryInvoiceWithNewPaymentMethod({
                customerId: this.userData.stripeCustomerId,
                paymentMethodId: result.paymentMethod.id,
                invoiceId: invoiceId,
                priceId: "price_1HFt1sH9q88vhZpEJFKGMDw7"
              });
            } else if (this.isAddCard) {
              this.attachCardToCustomer({
                customerId: this.userData.stripeCustomerId,
                paymentMethodId: result.paymentMethod.id
              });
            } else {
              // Create the subscription
              this.createSubscription({
                customerId: this.userData.stripeCustomerId,
                paymentMethodId: result.paymentMethod.id,
                priceId: this.selectedPrice.id //priceId
              });
            }
          }
        });
    },
    attachCardToCustomer({ customerId, paymentMethodId }) {
      console.log("CustomerDetail 2:", this.userData, customerId, paymentMethodId)
      firebase
        .functions()
        .httpsCallable("addCardToCustomer")({
          customerId,
          paymentMethodId
        })
        .then(() => {
          this.$router.push("/user/cards");
          this.$vToastify.success("Card has been added successfully");
        })
        .catch(err => {
          console.log("err", err);
          this.$vToastify.error("Failed to add card");
        });
    },
    createSubscription({ customerId, paymentMethodId, priceId }) {
      console.log("CustomerDetail:", this.userData, customerId, paymentMethodId, priceId)

      firebase
        .functions()
        .httpsCallable("createSubscription")({
          customerId,
          paymentMethodId,
          priceId
        })
        // If the card is declined, display an error to the user.
        .then(result => {
          if (result.error) {
            // The card had an error when trying to attach it to a customer.
            throw result;
          }
          return result.data;
        })
        // Normalize the result to contain the object returned by Stripe.
        // Add the additional details we need.
        .then(result => {
          return {
            paymentMethodId: paymentMethodId,
            priceId: priceId,
            subscription: result.subscription
          };
        })
        // Some payment methods require a customer to be on session
        // to complete the payment process. Check the status of the
        // payment intent to handle these actions.
        .then(this.handlePaymentThatRequiresCustomerAction)
        // If attaching this card to a Customer object succeeds,
        // but attempts to charge the customer fail, you
        // get a requires_payment_method error.
        .then(this.handleRequiresPaymentMethod)
        // No more actions required. Provision your service for the user.
        .then(this.onSubscriptionComplete)
        .catch(error => {
          // An error has happened. Display the failure to the user here.
          console.error(error);
          this.$vToastify.error(
            (error.error || {}).message ? error.error.message : ""
          );
        });
    },
    onSubscriptionComplete(result) {
      // Payment was successful.
      if (
        result.subscription.status === "active" ||
        ((result.subscription.latest_invoice || {}).payment_intent || {})
          .status == "succeeded" ||
        ((result || {}).paymentIntent || {}).status == "succeeded"
      ) {
        // Change your UI to show a success message to your customer.
        // Call your backend to grant access to your service based on
        // `result.subscription.items.data[0].price.product` the customer subscribed to.
        console.log(
          "result.subscription.items.data[0].price.product",
          result.subscription.items.data[0].price.product
        );
        this.$router.replace({
          name: "UserSubscription"
        });
        this.$vToastify.success("Subscription has been purchased successfully");
      }
    },
    handlePaymentThatRequiresCustomerAction({
      subscription,
      invoice,
      priceId,
      paymentMethodId,
      isRetry
    }) {
      if (subscription && subscription.status === "active") {
        // Subscription is active, no customer actions required.
        return { subscription, priceId, paymentMethodId };
      }

      // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
      // If it's a retry, the payment intent will be on the invoice itself.
      let paymentIntent = invoice
        ? invoice.payment_intent
        : subscription.latest_invoice.payment_intent;

      if (
        paymentIntent.status === "requires_action" ||
        (isRetry === true && paymentIntent.status === "requires_payment_method")
      ) {
        return this.stripe
          .confirmCardPayment(paymentIntent.client_secret, {
            payment_method: paymentMethodId
          })
          .then(result => {
            if (result.error) {
              // Start code flow to handle updating the payment details.
              // Display error message in your UI.
              // The card was declined (i.e. insufficient funds, card has expired, etc).
              throw result;
            } else {
              if (result.paymentIntent.status === "succeeded") {
                // Show a success message to your customer.
                // There's a risk of the customer closing the window before the callback.
                // We recommend setting up webhook endpoints later in this guide.
                return {
                  priceId: priceId,
                  subscription: subscription,
                  invoice: invoice,
                  paymentMethodId: paymentMethodId,
                  paymentIntent: result.paymentIntent
                };
              }
            }
          })
          .catch(error => {
            console.log("error occured", error);
            // displayError(error);
            throw error;
          });
      } else {
        // No customer action needed.
        return { subscription, priceId, paymentMethodId };
      }
    },
    handleRequiresPaymentMethod({
      subscription,
      paymentMethodId,
      priceId,
      invoice,
      paymentIntent
    }) {
      console.log("required payment method");
      if (subscription.status === "active") {
        // subscription is active, no customer actions required.
        return { subscription, priceId, paymentMethodId };
      } else if (
        subscription.latest_invoice.payment_intent.status ===
        "requires_payment_method"
      ) {
        // Using localStorage to manage the state of the retry here,
        // feel free to replace with what you prefer.
        // Store the latest invoice ID and status.
        // localStorage.setItem("latestInvoiceId", subscription.latest_invoice.id);
        // localStorage.setItem(
        //   "latestInvoicePaymentIntentStatus",
        //   subscription.latest_invoice.payment_intent.status
        // );
        throw { error: { message: "Your card was declined." } };
      } else {
        return {
          subscription,
          priceId,
          paymentMethodId,
          invoice,
          paymentIntent
        };
      }
    },
    retryInvoiceWithNewPaymentMethod({
      customerId,
      paymentMethodId,
      invoiceId,
      priceId
    }) {
      return (
        firebase
          .functions()
          .httpsCallable("retryInvoice")({
            customerId,
            paymentMethodId,
            invoiceId,
            priceId
          })
          .then(result => {
            if (result.error) {
              // The card had an error when trying to attach it to a customer.
              throw result;
            }
            return result;
          })
          // Normalize the result to contain the object returned by Stripe.
          // Add the additional details we need.
          .then(result => {
            return {
              // Use the Stripe 'object' property on the
              // returned result to understand what object is returned.
              invoice: result.data,
              paymentMethodId: paymentMethodId,
              priceId: priceId,
              isRetry: true
            };
          })
          // Some payment methods require a customer to be on session
          // to complete the payment process. Check the status of the
          // payment intent to handle these actions.
          .then(this.handlePaymentThatRequiresCustomerAction)
          // No more actions required. Provision your service for the user.
          .then(this.onSubscriptionComplete)
          .catch(error => {
            // An error has happened. Display the failure to the user here.
            console.log(error);
            this.$vToastify.error(
              (error.error || {}).message ? error.error.message : ""
            );
          })
      );
    }
  }
};
</script>
<style>
@import "../../assets/styles/payment.scss";
</style>
